
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

export default function BackendDownPage() {
  const navigate = useNavigate();
  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const handleGoHome = () => {
    navigate('/links');
  };

  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-100">
      <div className="text-center p-8 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-red-600">Backend Server is Down</h2>
        <p className="mt-4 text-gray-700">We are currently experiencing technical difficulties. Please try again later.</p>
        <div className="mt-6 space-x-4">
          <button
            onClick={handleGoHome}
            className="px-4 py-2 font-semibold text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            Home
          </button>
          <button
            onClick={handleLogout}
            className="px-4 py-2 font-semibold text-white bg-red-500 rounded hover:bg-red-600"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
